import React from 'react';
const PORTRAIT = 'https://cdn.magicpatterns.com/uploads/o2CvysesXKRQBRxSaUPsEV/1669136875918.jpg';
interface ProfileFrameProps {
  size?: 'full' | 'compact';
}

/**
 * Decorated boardroom plate: portrait set inside a double gold rule with
 * corner ornaments, name and headline engraved beneath.
 */
export function ProfileFrame({
  size = 'full'
}: ProfileFrameProps) {
  const isFull = size === 'full';
  return <figure className={['relative mx-auto bg-navy-800 pattern-grid', isFull ? 'max-w-md p-3' : 'max-w-xs p-2.5'].join(' ')} data-id="element-33" data-mp="4uunlh1n3wh5">
      {/* outer gold rule */}
      <span aria-hidden="true" className="pointer-events-none absolute inset-0 border border-gold/60" data-id="element-34" data-mp="duq29vuem9lx" />
      {/* inner hairline rule */}
      <span aria-hidden="true" className="pointer-events-none absolute inset-[7px] border border-white/12" data-id="element-35" data-mp="1p9mvlhxmfkz3" />
      {/* corner ornaments */}
      {['left-0 top-0 border-l-2 border-t-2', 'right-0 top-0 border-r-2 border-t-2', 'left-0 bottom-0 border-l-2 border-b-2', 'right-0 bottom-0 border-r-2 border-b-2'].map(pos => <span key={pos} aria-hidden="true" className={`pointer-events-none absolute h-6 w-6 border-gold ${pos}`} data-id="element-36" data-mp="2372itcqm8st8" />)}

      <div className={['relative flex flex-col items-center text-center', isFull ? 'px-7 py-9' : 'px-5 py-6'].join(' ')} data-id="element-37" data-mp="2c4cydaagv43y">
        <div className="relative" data-id="element-38" data-mp="1jgh2u8wmvi8r">
          <span aria-hidden="true" className="absolute -inset-2 border border-gold/40" data-id="element-39" data-mp="1jhs4a22lwdwp" />
          <img src={PORTRAIT} alt="Portrait of Janice Munday" className={['relative object-cover', isFull ? 'h-44 w-44' : 'h-28 w-28'].join(' ')} data-id="element-40" data-mp="1odz2f8orgl43" />
        </div>

        <div className="mt-9 flex items-center gap-3" aria-hidden="true" data-id="element-41" data-mp="10ppkwiykyjir">
          <span className="h-px w-10 bg-gold/50" data-id="element-42" data-mp="241544c0f4o29" />
          <span className="h-1.5 w-1.5 rotate-45 border border-gold" data-id="element-43" data-mp="23ztz68v8la9k" />
          <span className="h-px w-10 bg-gold/50" data-id="element-44" data-mp="1z33jhmncggoo" />
        </div>

        <h1 className={['mt-6 font-serif leading-tight text-white', isFull ? 'text-4xl sm:text-[2.75rem]' : 'text-2xl'].join(' ')} data-id="element-45" data-mp="2ctp69mfx5aru">
          Janice Munday
        </h1>

        <figcaption className="mt-5" data-id="element-46" data-mp="1l20zrgjtnigx">
          <p className={['font-medium uppercase tracking-[0.18em] text-gold', isFull ? 'text-[11px] leading-[1.9]' : 'text-[10px] leading-[1.8]'].join(' ')} data-id="element-47" data-mp="1l32hu4z99585">
            Chair
            <span className="mx-2 text-gold/40" data-id="element-48" data-mp="1p4e2dw39v09h">|</span>
            Independent Non-Executive Director
            <span className="mx-2 text-gold/40" data-id="element-49" data-mp="35i4817a1hwl8">|</span>
            Advanced Manufacturing &amp; Governance Leader
          </p>
        </figcaption>

        <span aria-hidden="true" className="mt-7 block h-px w-24 bg-gradient-to-r from-transparent via-gold/70 to-transparent" data-id="element-50" data-mp="30irj8gzlyfg0" />
        <p className="mt-4 text-[11px] uppercase tracking-overline text-slate-400" data-id="element-51" data-mp="3d2eufaj4grun">
          London · United Kingdom
        </p>
      </div>
    </figure>;
}